﻿import { Directive } from "@app/components/directive";
import { IExpanderGroupController } from "@app/components/kb-expander/kb-expander-group.component";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";

export interface IExpanderScope extends ng.IScope{
    expanded?: boolean;
    expandedChanged?: any;
    invalid?: boolean;
    icon?: string;
    image?: string;
    _toggle: () => void;
}

@NgComponent({
    token: Token.KbExpander,
    dependencies: [
        Token.$Timeout
    ]
})
export class KbExpander extends Directive {
    constructor(
        $timeout: ng.ITimeoutService
    ) {
        super();

        this.restrict = "E";
        this.template = Dirs.component("kb-expander");
        this.transclude = {
            "title": "?kbExpanderTitle",
            "body": "kbExpanderBody"
        };
        this.scope = {
            expanded: "=?",
            expandedChanged: "&",
            invalid: "=?",
            icon: "@",
            image: "@"
        };
        this.replace = false;
        this.require = "?^^kbExpanderGroup";

        this.link = (scope: IExpanderScope, element, atts, kbExpanderGroup: IExpanderGroupController) => {
            if (kbExpanderGroup) kbExpanderGroup.registerExpander(scope);
            scope._toggle = () => {
                scope.expanded = !scope.expanded;
            }
            scope.$watch("expanded", (newVal, oldVal) => {
                if (newVal != oldVal) {
                    if (kbExpanderGroup && scope.expanded) kbExpanderGroup.expand(scope);
                    if (scope.expandedChanged) scope.expandedChanged();
                }
            });
        };
    }
}
